<router-outlet></router-outlet>
<div class="leonus-loading-shade" *ngIf="loading$ | async">
  <mat-spinner></mat-spinner>
</div>
